import React from 'react';
import moment from 'moment';
import {Card} from '../Card';
import {Text} from '../Text';
import {Button} from '../Button';


export function PageCard(props) {
  return (
    <Card style={{padding:0, marginBottom:16, display:'flex', flexDirection:'row', alignItems:'stretch', ...props.style}}>
      <Button tertiary to={props.onClick ? null : `/pages/${props.id}`} style={{display:'block', flex:1, padding:16}} onClick={props.onClick}>
        <Text block semibold color="#5cc2e8" style={{marginBottom:4}}>{props.name}</Text>
        <Text block small style={{marginBottom:12}}>
          Created: {moment(props.dateModified || props.dateCreated).format("MMMM DD")}
        </Text>
      </Button>
      <div 
        style={{
          width: 80,
          height: 100,
          margin: 8,
          backgroundImage: props.preview ? `url(${props.preview})` : 'none',
          backgroundPosition: 'top center',
          backgroundSize: 'cover',
        }}
      />
    </Card>
  );  
}